// extracted by mini-css-extract-plugin
export var errorsContainer = "_r8-1";
export var link = "_r8-0";